module.exports = __webpack_public_path__ + "static/wn_mobile-3f3b27fd9518e4b52814d0cc27db6f28.png";